import actionTypes from '../actionTypes';
import { isSaturday } from '../../helper/date';

const initialState = {
	netSalesData: {},
	netSalesLoading: true,
	netSalesErrorCode: 0,
	unitData: {},
	unitLoading: true,
	unitErrorCode: 0,
	gmvData: {},
	gmvLoading: false,
	gmvErrorCode: 0,
	cbSalesData: {},
	cbUnitsData: {},
	cbGMVData: {},
	cbSalesLoading: true,
	cbSalesErrorCode: 0,
	selectedFilters: {
		// Week filter default value is 13, Only if Saturday, Then we will make it Last walmart week
		weekFilter: isSaturday ? 1 : 13,
		selectedFilter: 'Omni',
		startDate: '',
		endDate: '',
	},
	kpiName: 'netsales',
	tabValue: 'Dashboard',

	validateUpc: {},
	validateLoading: false,
	validateErrorCode: 0,

	selectedUPC: [],
	reloadTable: false,

	dataRefreshTimestamp: null,
	dataRefreshTimestampLoading: false,
	dataRefreshTimestampErrorCode: 0,
};

const salesReducer = (state = initialState, action = {}) => {
	switch (action?.type) {
		case actionTypes.GET_DATA_REFRESH_TIMESTAMPS_FAILURE:
			return {
				...state,
				dataRefreshTimestampErrorCode: action.payload,
				dataRefreshTimestampLoading: false,
				dataRefreshTimestamp: '/-/-/',
			};
		case actionTypes.GET_DATA_REFRESH_TIMESTAMPS_SUCCESS:
			return {
				...state,
				dataRefreshTimestampLoading: false,
				dataRefreshTimestampErrorCode: 0,
				dataRefreshTimestamp: action.payload,
			};
		case actionTypes.GET_DATA_REFRESH_TIMESTAMPS:
			return {
				...state,
				dataRefreshTimestampLoading: true,
			};
		case actionTypes.GET_NET_SALES:
			return {
				...state,
				netSalesLoading: true,
			};
		case actionTypes.GET_NET_SALES_SUCCESS:
			return {
				...state,
				netSalesData: action.payload,
				netSalesLoading: false,
				netSalesErrorCode: 0,
			};
		case actionTypes.GET_NET_SALES_FAILURE:
			return {
				...state,
				netSalesData: {},
				netSalesLoading: false,
				netSalesErrorCode: action.payload,
			};
		case actionTypes.GET_UNIT:
			return {
				...state,
				unitLoading: true,
			};
		case actionTypes.GET_UNIT_SUCCESS:
			return {
				...state,
				unitData: action.payload,
				unitLoading: false,
				unitErrorCode: 0,
			};
		case actionTypes.GET_UNIT_FAILURE:
			return {
				...state,
				unitData: {},
				unitLoading: false,
				unitErrorCode: action.payload,
			};
		//Net Sales
		case actionTypes.GET_CHANNEL_BREAKDOWN_SALES:
			return {
				...state,
				cbSalesLoading: true,
			};
		case actionTypes.GET_CHANNEL_BREAKDOWN_SALES_SUCCESS:
			return {
				...state,
				cbSalesData: action.payload,
				cbSalesLoading: false,
				cbSalesErrorCode: 0,
			};
		case actionTypes.GET_CHANNEL_BREAKDOWN_UNITS_SUCCESS:
			return {
				...state,
				cbUnitsData: action.payload,
				cbSalesLoading: false,
			};
		case actionTypes.GET_CHANNEL_BREAKDOWN_GMV_SUCCESS:
			return {
				...state,
				cbGMVData: action.payload,
				cbSalesLoading: false,
			};
		case actionTypes.GET_CHANNEL_BREAKDOWN_SALES_FAILURE:
			return {
				...state,
				cbSalesData: {},
				cbUnitsData: {},
				cbGMVData: {},
				cbSalesLoading: false,
				cbSalesErrorCode: action.payload,
			};
		case actionTypes.SAVE_WEEK_FILTER:
			return {
				...state,
				selectedFilters: { ...state?.selectedFilters, ...action.payload },
			};
		case actionTypes.RELOAD_SHOW_HIDE_COL:
			return {
				...state,
				reloadTable: action.payload,
			};
		case actionTypes.SAVE_KPI_NAME:
			return {
				...state,
				kpiName: action.payload,
			};
		case actionTypes.SET_TAB_VALUE:
			return {
				...state,
				tabValue: action.payload,
			};

		case actionTypes.GET_UPC_VALIDATION:
			return {
				...state,
				validateLoading: true,
			};

		case actionTypes.GET_UPC_VALIDATION_SUCCESS:
			return {
				...state,
				validateUpc: action.payload,
				validateLoading: false,
				validateErrorCode: 0,
			};

		case actionTypes.GET_UPC_VALIDATION_FAILURE:
			return {
				...state,
				validateUpc: {},
				validateLoading: false,
				validateErrorCode: action.payload,
			};

		case actionTypes.SELECTED_UPCS:
			return {
				...state,
				selectedUPC: action.payload,
			};

		default:
			return state;
	}
};

export default salesReducer;
